<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-modal-print
                                ref="print"
                                @close-method="file_name = null, $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <v-menu left content-class="no-stripe" v-if="selected_wo.length > 0">
                                <template slot="activator">
                                    <v-btn icon>
                                        <v-icon>print</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile v-for="item in printOptions" :key="item.title" @click="showPrinter(item.type)">
                                        <v-icon class="mr-2" size="20">{{ item.icon }}</v-icon>
                                        <v-list-tile-title>
                                            {{ $t(`lang.${item.title}`) }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn
                                        v-if="(warehouse && warehouse.length > 0) || warehouse_dialog"
                                        icon
                                        @mouseup.left="getWarehouse(true)"
                                    >
                                        <v-icon class="material-icons-outlined">warehouse</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t('lang.warehouse') }}
                            </bc-tooltip>
                            <bc-btn-refresh
                                permanent
                                @invoke-method="dbRefreshPage()"
                            ></bc-btn-refresh>
                            <!-- <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav> -->
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : 'pt-1'">
                    <v-layout row wrap mb-2 pb-1>
                        <v-flex xs12 sm5 class="d-inline-flex">
                            <bc-autocomplete
                                v-model="filter.short_code"
                                :label="$t('lang.furnace')"
                                :items="furnaces || []"
                                item-value="short_code"
                                item-text="short_code"
                                no-data-text="None Active"
                                :hide-details="true"
                                class="mr-2"
                                :class="{ 'ml-2': $bp.xsOnly }"
                                @change="getPatterns($event)"
                                clearable
                                @click:clear="$nextTick(() => { clearShortCode() })"
                                set-max-width="200"
                            ></bc-autocomplete>
                            <bc-autocomplete
                                v-model="filter.pattern_number"
                                :label="$t('lang.pattern_number')"
                                :items="patterns"
                                item-value="pattern_number"
                                item-text="pattern_number"
                                :no-data-text="$t('lang.select_furnace')"
                                :hide-details="true"
                                :class="$bp.xsOnly ? 'mr-2' : 'mr-auto'"
                                clearable
                                @click:clear="filterClearInput()"
                                set-max-width="200"
                            ></bc-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 offset-sm1 md3 offset-md4 class="d-inline-flex">
                            <bc-date-picker
                                v-model="filter.date_scheduled"
                                :label="$t('lang.date')"
                                @update="filter.date_scheduled = $event"
                                :class="{ 'ml-auto': $bp.smAndUp, 'ml-2': $bp.xsOnly }"
                                :hide-details="true"
                                :clearable="filter.date_scheduled != default_filter.date_scheduled"
                                @click:clear="filterClearInput('date_scheduled')"
                                max-width="200"
                            ></bc-date-picker>
                            <v-btn
                                @mouseup.left="filterTool(axiosParams)"
                                color="primary"
                                class="mb-0 mt-3"
                                :disabled="!allow_filter"
                            >
                                {{$t('lang.filter')}}
                            </v-btn>
                        </v-flex>
                        <!-- <v-flex xs6 sm1>
                            <v-btn
                                @mouseup.left="filterTool(axiosParams)"
                                color="primary"
                                class="mb-0 mt-3"
                                :disabled="!allow_filter"
                            >
                                {{$t('lang.filter')}}
                            </v-btn>
                        </v-flex> -->
                    </v-layout>
                    <v-data-table
                        v-model="selected_wo"
                        :headers="headers"
                        :items="work_orders_batches"
                        item-key="batch_id"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        select-all
                    >
                        <template slot="items" slot-scope="props">
                            <tr :active="props.selected">
                                <td>
                                    <v-checkbox
                                        @click.stop="props.selected = !props.selected"
                                        :input-value="props.selected"
                                        primary
                                        hide-details
                                        :disabled="props.item.approved_for_production == '0'"
                                        :indeterminate="props.item.approved_for_production == '0'"
                                        indeterminate-icon="close"
                                    ></v-checkbox>
                                </td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }">{{ props.item.company }}</td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }">{{ props.item.customer_part_number }}</td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }">{{ props.item.name }}</td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }" class="text-center">{{ props.item.batch_size ? props.item.batch_size : '' }}</td>
								<td v-if="props.item.date_scheduled" @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }" class="text-center">{{ props.item.date_scheduled }}</td>
								<td v-else>
                                    <v-btn
                                        style="min-width: 110px;"
                                        class="my-0 align-center"
                                        :color="props.item.approved_for_production == '0' ? 'success' : 'primary'"
                                        flat
                                        @mouseup.left="props.item.approved_for_production == '0' ? openApproveDialog(props.item) : openScheduleDialog(props.item) "
                                    >
                                        {{ props.item.approved_for_production == '0' ? $t('lang.approve') : $t('lang.schedule') }}
                                    </v-btn>
                                </td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }">{{ props.item.current_station }}</td>
								<td @click="openProfile(props.item)" :class="{ 'clickable': props.item.date_scheduled }">{{ props.item.status ? props.item.status.status : '' }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="continuous_line"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="warehouse_dialog" :max-width="current_part ? 800 : 1000">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ current_part ? $t('lang.create_batches') : $t('lang.warehouse') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeWarehouseDialog"
                            :dialog-status="warehouse_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text :class="{ 'pa-0': !current_part }">
                        <v-form ref="schedule" v-if="current_part" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12 sm5 align-self-start pa-0>
										<vue-perfect-scrollbar class="scroll-area" :style="$bp.xs ? null : this.$bp.smallScreen ? 'max-height: calc(100vh - 160px)' : 'max-height: calc(90vh - 160px)'">
                                            <v-layout
                                                row
                                                v-for="(item, index) in schedule"
                                                :key="`schedule-${index}`"
                                                class="schedule-list py-2"
                                                :class="{ 'grey lighten-3': index % 2 == 1 }"
                                            >
                                                <v-flex xs9 my-auto pl-2 pr-1>
                                                    {{ item.name }}
                                                    <br/>
                                                    {{ item.batch_control_id }}
                                                    <br/>
                                                    Qty: {{ item.warehouse_qty }}
                                                </v-flex>
                                                <v-flex xs3 pl-0 pr-3 my-auto>
                                                    <v-text-field
                                                        v-model="schedule_qty[index]"
                                                        :label="$t('lang.qty')"
                                                        hide-details
                                                        single-line
                                                        outline
                                                        class="center-label"
                                                        :class="+schedule_qty[index] > +schedule[index].warehouse_qty || (schedule_qty[index] != '' && !Number.isInteger(+schedule_qty[index])) || (schedule_qty[index] != '' && +schedule_qty[index] < 0) ? 'qty-error' : +schedule_qty[index] == +schedule[index].warehouse_qty ? 'qty-full' : +schedule_qty[index] > 0 ? 'qty-partial' : null"
                                                        :rules="ifValid([...$r.min_value(0), ...$r.max_value(item.warehouse_qty), ...$r.integer()])"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </vue-perfect-scrollbar>
									</v-flex>
									<v-flex xs12 sm7 align-self-start :class="{ 'pl-3 pt-2': $bp.smAndUp }">
                                        <h1>{{ current_part.name }}</h1>
                                        <h1>{{ current_part.customer_part_number }}</h1>
                                        <h1>{{ current_part.company }}</h1>
                                        <v-layout row wrap class="pt-3">
                                            <v-flex pa-0 xs8>
                                                <h3>Batch Size</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center">{{ current_part.batch_size }}</h3>
                                            </v-flex>
                                            <v-flex xs8 py-0>
                                            </v-flex>
                                            <v-flex xs4 py-0>
                                                <v-divider class="mt-0"></v-divider>
                                            </v-flex>
                                            <v-flex pa-0 xs8>
                                                <h3>Total Batches</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center">{{ total_batches }}</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs12 mb-3>
                                                <v-divider class="my-0"></v-divider>
                                            </v-flex>
                                            <v-flex xs12 v-for="i in Object.keys(slug_group).length" :key="'station-'+i">
                                                <v-layout row>
                                                    <v-flex pa-0 xs4 my-auto>
                                                        <h4 class="mb-0">{{ $t(`lang.${filtered_group[Object.keys(filtered_group)[i-1]][0].slug}`) }}</h4>
                                                    </v-flex>
                                                    <v-flex pa-0 xs8>
                                                        <v-select
                                                            v-model="station_options[i-1]"
                                                            :label="$t('lang.station_id')"
                                                            :items="slug_group[filtered_group[Object.keys(filtered_group)[i-1]][0].slug] || []"
                                                            item-value="part_station_id"
                                                            item-text="label"
                                                            class="pt-0 mb-0"
                                                            hide-details
                                                            single-line
                                                        ></v-select>
                                                    </v-flex>
                                                <!-- {{ i }} {{ Object.keys(filtered_group) }} {{ Object.keys(filtered_group)[i-1] }} -->
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
									</v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-data-table
                            v-else
                            :headers="warehouse_headers"
                            :items="warehouse"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                        >
                            <template slot="items" slot-scope="props">
                                <tr class="clickable" @mouseup.left="getDefaultSchedule(props.item)">
                                    <td class="text-center"><v-icon v-if="props.item.days_aged_icon" :color="props.item.days_aged_class">{{ props.item.days_aged_icon }}</v-icon></td>
                                    <td class="text-center">{{ props.item.days_aged }}</td>
                                    <td>{{ props.item.company }}</td>
                                    <td>{{ props.item.customer_part_number }}</td>
                                    <td>{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.warehouse_qty }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions v-if="current_part">
                        <v-btn color="secondary" @mouseup.left="current_part = null">
                            <v-icon class="mr-1">keyboard_return</v-icon>
                            {{$t('lang.back')}}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeWarehouseDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn
                            @mouseup.left="partial_batch > 0 ? confirmSchedule() : scheduleBatch()"
                            :disabled="station_options.includes(null || undefined) || total_batches <= 0"
                            color="success"
                        >
                            {{$t('lang.save')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="schedule_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t('lang.schedule') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="schedule_dialog"
                            :dialog-status="schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="schedule_date">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="start_date"
                                            :label="$t('lang.date')"
                                            @update="start_date = $event"
                                            :rules="ifValid($r.required(true))"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-time-picker
                                            v-model="start_time"
                                            :label="$t('lang.time')"
                                            @update="start_time = $event"
                                            :rules="ifValid($r.required(true))"
                                        ></bc-time-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="edit_schedule.lot_number"
                                            :label="$t('lang.lot_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="edit_schedule.po_number"
                                            :label="$t('lang.po_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="edit_schedule.jig_tag_number"
                                            :label="$t('lang.jig_tag_number')"
                                            :rules="ifValid([...$r.required(true)])"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="edit_schedule.empty_box_location"
                                            :label="$t('lang.empty_box_location')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-for="i in Object.keys(slug_group).length" :key="'station-'+i">
                                        <v-layout row>
                                            <v-flex pa-0 xs4 my-auto>
                                                <h4 class="mb-0">{{ $t(`lang.${filtered_group[Object.keys(filtered_group)[i-1]][0].slug}`) }}</h4>
                                            </v-flex>
                                            <v-flex pa-0 xs8>
                                                <v-select
                                                    v-model="station_options[i-1]"
                                                    :label="$t('lang.station_id')"
                                                    :items="slug_group[filtered_group[Object.keys(filtered_group)[i-1]][0].slug] || []"
                                                    item-value="part_station_id"
                                                    item-text="label"
                                                    class="pt-0 mb-0"
                                                    hide-details
                                                    single-line
                                                ></v-select>
                                            </v-flex>
                                        <!-- {{ i }} {{ Object.keys(filtered_group) }} {{ Object.keys(filtered_group)[i-1] }} -->
                                        </v-layout>
                                    </v-flex>
                                    <template v-if="Object.keys(slug_group).length == 0" >
                                        <v-flex v-for="(s,i) in temp_stations" :key="i">
                                            <v-layout row>
                                                <v-flex pa-0 xs4 my-auto>
                                                    <h4 class="mb-0">{{ $t(`lang.${s}`) }}</h4>
                                                </v-flex>
                                                <v-flex pa-0 xs8>
                                                    <v-select
                                                        :items="[]"
                                                        class="pt-0 mb-0"
                                                        hide-details
                                                        single-line
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </template>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="schedule_dialog = false">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyBatch(current_batch)">{{ $t('lang.save') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="approve_schedule_dialog" max-width="600">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t('lang.prototype') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="approve_schedule_dialog"
                            :dialog-status="approve_schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">Allow this prototype to be added to the schedule?</span>
                        <h2 class="ml-3 mt-3">{{ currApproveField('company') }}</h2>
                        <h2 class="ml-3">{{ currApproveField('customer_part_number') }}</h2>
                        <h2 class="ml-3">{{ currApproveField('name') }}</h2>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="approve_schedule_dialog = false">{{$t('lang.cancel')}}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="approveBatch()"
                        >
                            {{$t('lang.approve')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="confirm_schedule_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t('lang.partial_batch') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="confirm_schedule_dialog"
                            :dialog-status="confirm_schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">You are attempting to schedule {{ Math.floor(total_batches) > 0 ? Math.floor(total_batches) > 1 ? `${Math.floor(total_batches)} full batches and` : '1 full batch and' : ''}} a partial batch that is <span style="text-decoration: underline" class="fw-bold">{{ partial_batch }}%</span> full. Are you sure you want to continue?</span>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="confirm_schedule_dialog = false">{{$t('lang.no')}}</v-btn>
                        <v-btn
                            color="success"
                            @mouseup.left="scheduleBatch()"
                        >
                            {{$t('lang.yes')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.customer"), sortable: false, width: "20%" },
                { text: this.$t("lang.part_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.qty"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.date_scheduled"), sortable: false, width: "15%", align: "center" },
                { text: this.$t("lang.current_station"), sortable: false, width: "15%" },
                { text: this.$t("lang.status"), sortable: false, width: "10%" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), sortable: false, width: "10%", align: "center" },
                { text: this.$t("lang.customer"), sortable: false, width: "25%" },
                { text: this.$t("lang.part_number_short"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "30%" },
                { text: this.$t("lang.warehouse_qty"), sortable: false, width: "15%", align: "center" },
                // { text: '', sortable: false, width: '15%' },
            ],
            slug_group: {},
            filtered_group: {},
            station_options: [],
            selected_wo: [],
            machine: {
                pattern_number: "",
                machine_name: "",
                short_code: "",
            },
            schedule_qty: [],
            grouped_stations: {},
            current_obj: null,
            filter: {
                furnace: null,
                pattern_number: null,
                date_scheduled: this.current_day,
                page_size: 0,
                page_num: 0,
            },
            start_time: null,
            start_date: null,
            current_batch: null,
            current_warehouse: null,
            current_part: null,
            warehouse_dialog: false,
            schedule_dialog: false,
            confirm_schedule_dialog: false,
            approve_schedule_dialog: false,
            end_loader: false,
            current_approve: null,
            file_name: null,
            edit_schedule: {
                jig_tag_number: "",
                empty_box_location: "",
                lot_number: "",
                po_number: "",
            },
            temp_stations: ["setting", "pre_wash", "furnace", "post_wash", "temper"],
            printOptions: [
                { title: "documents", icon: "description", type: "print_process_sheet" },
                { title: "label", icon: "label", type: "print_4x6_label" },
            ],
            mobile_list: [{ title: this.$t("lang.refresh"), action: "dbRefreshPage" }],
            dbRefreshPage: _.debounce(this.getRefresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        const work_orders_batches = new Promise((resolve, reject) => {
            store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batches",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: { ...parsedQuery, line_id: 2 },
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.work_orders_batches) : reject(new Error("reject"));
                });
        });
        store.dispatch("fetchWorkOrder", {
            url: "warehouse?line_id=2",
            method: "get",
            stateProperty: "warehouse",
            commit: true,
        });
        store.dispatch("fetchMachines", {
            url: "machines/?line_id=2&slug=furnace",
            method: "get",
            stateProperty: "furnaces",
            dataProperty: "machines",
            commit: true,
        });
        if (to.query && to.query.short_code) {
            store.dispatch("fetchWorkOrder", {
                url: "work_orders/active_patterns",
                method: "get",
                stateProperty: "patterns",
                commit: true,
                body: {
                    line_id: 2,
                    short_code: to.query.short_code,
                },
            });
        }

        Promise.all([work_orders_batches])
            .then(([work_orders_batches]) => {
                // console.log(work_orders_batches)
                if (typeof work_orders_batches !== "undefined") {
                    next((vm) => {
                        vm.$store.commit("commitWorkOrder", { property: "continuous_filter.date_scheduled", with: vm.current_day });
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            })
            .catch((error) => {
                console.log("error", error);
                store.commit("toggleLoginLoader", false);
                store.commit("finishLoader");
                next(false); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        const work_orders_batches = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batches",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: { ...parsedQuery, line_id: 2 },
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.work_orders_batches) : reject(new Error("reject"));
                });
        });

        store.dispatch("fetchMachines", {
            url: "machines/?line_id=2&slug=furnace",
            method: "get",
            stateProperty: "furnaces",
            dataProperty: "machines",
            commit: true,
        });
        if (to.query && to.query.short_code) {
            store.dispatch("fetchWorkOrder", {
                url: "work_orders/active_patterns",
                method: "get",
                stateProperty: "patterns",
                commit: true,
                body: {
                    line_id: 2,
                    short_code: to.query.short_code,
                },
            });
        }

        Promise.all([work_orders_batches])
            .then(([work_orders_batches]) => {
                if (typeof work_orders_batches !== "undefined") {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            })
            .catch((error) => {
                this.$store.commit("finishLoader");
                next(false); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    computed: {
        ...mapState({
            rules_machines: (state) => state.validation.rules_machines,
            rules_batches: (state) => state.validation.rules_batches,
            default_filter: (state) => state.work_orders.continuous_filter,
            page: (state) => state.work_orders.page,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
            work_orders_batches: (state) => state.work_orders.work_orders_batches,
            warehouse: (state) => state.work_orders.warehouse,
            schedule: (state) => state.work_orders.schedule,
            furnaces: (state) => state.machines.furnaces,
            patterns: (state) => state.work_orders.patterns,
        }),
        axiosParams() {
            let prep_filter = {};
            prep_filter = JSON.parse(JSON.stringify(this.filter));
            if (!(this.filter.short_code && this.filter.pattern_number)) {
                prep_filter.short_code = "";
                prep_filter.pattern_number = "";
            }
            return this.prepareParams(prep_filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currApproveField() {
            return (field) => {
                return this.current_approve && field && this.current_approve[field] ? this.current_approve[field] : "";
            };
        },
        total_qty() {
            return _.sumBy(this.schedule_qty || [], (qty) => +qty);
        },
        total_batches() {
            let total = 0;
            if (this.current_part && !!(+this.total_qty / +this.current_part.batch_size)) {
                total = Math.ceil((+this.total_qty / +this.current_part.batch_size) * 1000) / 1000;
            }
            return Math.max(total, 0);
        },
        partial_batch() {
            if (!this.current_part || !this.total_qty) return 0;
            return Math.ceil((this.total_batches * 1000) % 1000) / 10;
        },
        allow_filter() {
            let diff_params =
                (this.axiosParams && Object.keys(this.axiosParams).length > 0 && JSON.stringify(this.axiosParams) != JSON.stringify(this.$route.query)) ||
                JSON.stringify(this.axiosParams) != JSON.stringify(this.$route.query) ||
                (!!this.filter.date_scheduled && !!this.$route.query.date_scheduled && this.$route.query.date_scheduled != this.filter.date_scheduled);
            return diff_params && ((!!this.filter.short_code && !!this.filter.pattern_number) || (!this.filter.short_code && !this.filter.pattern_number));
        },
        // startAndEnd() { const {short_code, pattern_number} = this.filter; return { short_code, pattern_number }; },
    },
    watch: {
        // startAndEnd(newVal, oldVal) {
        //     console.log(newVal, oldVal)
        //     if(newVal.short_code && newVal.pattern_number && (oldVal.short_code || oldVal.pattern_number)){
        //         this.filterTool({ short_code: newVal.short_code, pattern_number: newVal.pattern_number})
        //     }
        // },
    },
    methods: {
        openApproveDialog(item) {
            this.approve_schedule_dialog = true;
            this.current_approve = item;
        },
        openScheduleDialog(batch) {
            this.getDefaultSchedule(batch, false);
            this.current_batch = batch;
            this.schedule_dialog = true;
            this.edit_schedule.lot_number = "";
            this.edit_schedule.po_number = "";
            this.edit_schedule.jig_tag_number = "";
            this.edit_schedule.empty_box_location = "";
            this.start_date = this.current_day;
            this.start_time = this.current_time;
        },
        modifyBatch(batch = null) {
            if (batch) {
                let id = batch.batch_id;
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("schedule_date")) {
                        let _batch_obj = this.edit_schedule;
                        _batch_obj.date_scheduled = `${this.start_date} ${this.start_time}`;
                        _batch_obj.part_station_id = this.station_options;
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: id,
                                url: `work_orders/${batch.work_order_id}/batches/${id}`,
                                method: "patch",
                                stateProperty: "work_orders_batches",
                                dataProperty: "work_orders_batch",
                                mutate: true,
                                body: _batch_obj,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.schedule_dialog = false;
                                    this.$store.commit("validationOff");
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        getRefresh() {
            this.startLoader();
            this.end_loader = true;
            this.getWarehouse(false);
            this.getWorkOrders(false);
            this.getFurnaces();
        },
        clearShortCode() {
            this.filter.short_code = null;
            this.filter.pattern_number = "";
        },
        getFurnaces() {
            this.$store.dispatch("fetchMachines", {
                url: "machines/?line_id=2&slug=furnace",
                method: "get",
                stateProperty: "furnaces",
                dataProperty: "machines",
                commit: true,
            });

            if (this.$route.query && this.$route.query.short_code) {
                store.dispatch("fetchWorkOrder", {
                    url: "work_orders/active_patterns",
                    method: "get",
                    stateProperty: "patterns",
                    commit: true,
                    body: {
                        line_id: 2,
                        short_code: this.$route.query.short_code,
                    },
                });
            }
        },
        getPatterns(short_code) {
            if (short_code) {
                this.$store.commit("commitWorkOrder", { property: "patterns", with: null });
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders/active_patterns",
                        method: "get",
                        stateProperty: "patterns",
                        commit: true,
                        body: {
                            line_id: 2,
                            short_code: short_code,
                        },
                    })
                    .then((data) => {
                        if (typeof data == "undefined" || !data.patterns) {
                            this.$store.commit("commitWorkOrder", { property: "patterns", with: [] });
                        }
                    });
            } else {
                this.$store.commit("commitWorkOrder", { property: "patterns", with: [] });
            }
        },
        openProfile(order) {
            if (order && order.work_order_id && order.batch_id && order.date_scheduled) {
                this.$router.push({ name: "batch_profile", params: { work_order_id: order.work_order_id, batch_id: order.batch_id } });
            }
        },
        showPrinter(type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batches/${type}`,
                    method: "get",
                    body: {
                        batch_id: this.selected_wo.map((w) => w.batch_id),
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.file_name = data.process_sheet.file_name;
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.file_name = data.bill_of_lading.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        scheduleBatch() {
            // alert('schedule')
            if (this.validateForm("schedule")) {
                let batches = [];
                this.schedule.forEach((s, i) => {
                    // only send if a qty is entered
                    if (!!this.schedule_qty[i] && +this.schedule_qty[i] > 0) {
                        batches.push({
                            receiving_id: s.receiving_id,
                            batch_qty: this.schedule_qty[i],
                        });
                    }
                });

                let schedule_obj = {
                    company_id: this.current_part.company_id,
                    part_id: this.current_part.part_id,
                    part_station_id: this.station_options,
                    batches: batches,
                };
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders",
                        method: "post",
                        stateProperty: "work_orders_batches",
                        mutate: true,
                        body: schedule_obj,
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            if (+this.current_part.warehouse_qty - this.total_qty > 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "patch",
                                    id: data.work_orders_batches[0].part_id,
                                    pk: "part_id",
                                    with: {
                                        part_id: data.work_orders_batches[0].part_id,
                                        warehouse_qty: (+this.current_part.warehouse_qty - this.total_qty).toString(),
                                        batched_qty: (+this.current_part.batched_qty + this.total_qty).toString(),
                                    },
                                });
                            } else if (+this.current_part.warehouse_qty - this.total_qty == 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "delete",
                                    id: data.work_orders_batches.part_id,
                                    pk: "part_id",
                                });
                            }
                            this.warehouse_dialog = false;
                            this.confirm_schedule_dialog = false;
                            setTimeout(() => {
                                this.current_part = null;
                            }, 300);
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        confirmSchedule() {
            if (this.validateForm("schedule")) {
                this.confirm_schedule_dialog = true;
            }
        },
        getWorkOrders(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batches",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: { ...JSON.parse(JSON.stringify(this.$route.query)), line_id: 2 },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.work_order_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    if (status) this.finishLoader();
                    if (!status && this.end_loader) {
                        this.finishLoader(true);
                        this.end_loader = false;
                    }
                });
        },
        getArrayData() {
            if (this.production_lines == null) this.getProductionLines();
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.current_part = null;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=2",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getDefaultSchedule(part = null, fill_batches = true) {
            if (part) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `warehouse/by_part_id/${part.part_id}/2`,
                        method: "get",
                        stateProperty: "schedule",
                        dataProperty: "parts.warehouse",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.parts) {
                            this.current_part = data.parts;
                            this.current_warehouse = part;
                            this.grouped_stations = {};
                            this.station_options = [];
                            if (data.parts.parts_stations) {
                                this.grouped_stations = _.groupBy(data.parts.parts_stations, "sort_order");
                                let filter_group = JSON.parse(JSON.stringify(this.grouped_stations));
                                let slug_group = {};
                                for (const [key, value] of Object.entries(filter_group)) {
                                    // for (let j=0; j < value.length; j++) { if(value[j].slug == 'setting'){ value.splice(j,1) } }
                                    if (value.length == 0) {
                                        delete filter_group[key];
                                    } /* else if(value.length == 1) {
                                        this.station_options.push(value[0].part_station_id)
                                    } */ else {
                                        let group = {};
                                        if (fill_batches) {
                                            group = value.filter((e) => e.prime == "1");
                                            if (group && group.length > 0) {
                                                this.station_options.push(group[0].part_station_id);
                                            } else {
                                                this.station_options.push(value[0].part_station_id);
                                            }
                                        } else {
                                            if (value.length > 1) {
                                                let slug = value[0].slug;
                                                group = value.filter(
                                                    (e) =>
                                                        e.short_code == this.current_batch[`${slug}`] &&
                                                        e.pattern_number == this.current_batch[`${slug}_pattern`]
                                                )[0];
                                                this.station_options.push(group.part_station_id);
                                            } else {
                                                group = value[0];
                                                this.station_options.push(group.part_station_id);
                                            }
                                        }
                                        slug_group[group[0].slug] = value;
                                    }
                                }
                                this.slug_group = slug_group;
                                this.filtered_group = filter_group;
                            }
                            if (fill_batches && data.parts.warehouse) {
                                this.schedule_qty = Array(data.parts.warehouse.length).fill("");
                            }
                            // console.log(+part.warehouse_qty, +data.parts.warehouse_qty, '!=', +part.warehouse_qty != +data.parts.warehouse_qty)
                            if (fill_batches && +part.warehouse_qty != +data.parts.warehouse_qty) {
                                if (+data.parts.warehouse_qty == 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "delete",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                    });
                                } else {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "patch",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                        with: {
                                            batched_qty: data.parts.batched_qty,
                                            warehouse_qty: data.parts.warehouse_qty,
                                            received_qty: data.parts.received_qty,
                                        },
                                    });
                                }
                            }
                            // auto fill batches
                            if (fill_batches && +data.parts.warehouse_qty > 0 && data.parts.batch_size) {
                                let curr_index = 0;
                                let curr_warehouses = this.schedule.map((a) => a.warehouse_qty);
                                let batch_size = +data.parts.batch_size;
                                let batches_needed = Math.floor(+data.parts.warehouse_qty / batch_size);

                                for (let x = 0; x < batches_needed; x++) {
                                    let skip = false;
                                    let current_batch = 0;
                                    for (let k = 0; k < curr_warehouses.length && !skip && current_batch < batch_size; k++) {
                                        if (curr_warehouses[k] > 0) {
                                            let w = curr_warehouses[k];
                                            if (this.schedule_qty[curr_index] == "") this.schedule_qty[curr_index] = 0;
                                            if (current_batch + +w <= batch_size) {
                                                this.schedule_qty[curr_index] += +w;
                                                curr_warehouses[k] = 0;
                                                current_batch += +w;
                                                if (this.schedule_qty[curr_index] == batch_size) {
                                                    skip = true;
                                                }
                                                curr_index++;
                                            } else {
                                                let num_to_pull = batch_size - current_batch;
                                                current_batch += +num_to_pull;
                                                this.schedule_qty[curr_index] = this.schedule_qty[curr_index] + num_to_pull;
                                                curr_warehouses[k] = +w - num_to_pull;
                                                if (w == 0) curr_index++;
                                                skip = true;
                                            }
                                        }
                                    }
                                }
                                this.schedule_qty = this.schedule_qty.map(String);
                            } else {
                                this.current_part = null;
                                this.$store.commit("toggleModalLoader", false);
                            }
                            // data.parts.warehouse.forEach(w => { console.log(w) this.$store.commit('mutateWorkOrder', { property: 'schedule', with: w, method: 'post' }) })
                        }
                    })
                    .finally(() => {
                        this.$store.commit("validationOn");
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        approveBatch() {
            if (this.currApproveField("batch_id")) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        pk: "batch_id",
                        id: this.currApproveField("batch_id"),
                        url: `work_orders/${this.currApproveField("work_order_id")}/batches/${this.currApproveField("batch_id")}/approve`,
                        method: "patch",
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            this.approve_schedule_dialog = false;
                            this.$store.commit("mutateWorkOrder", {
                                property: "work_orders_batches",
                                method: "patch",
                                id: data.work_orders_batch_approval.batch_id,
                                pk: "batch_id",
                                with: {
                                    approved_for_production: "1",
                                },
                            });
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        modifyMachine(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("machines")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchMachines", {
                                pk: "machine_id",
                                id: id,
                                url: `machines/${id ? id : ""}`,
                                method: method,
                                stateProperty: "machines",
                                mutate: true,
                                body: this.machine,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeMachineDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showMachine(item = null) {
            this.current_obj = item;
            this.getArrayData();
            if (this.$refs.machines) item ? this.$refs.machines.resetValidation() : this.$refs.machines.reset();

            this.$nextTick(() => {
                this.assignObj(this.machine, item, this.rules_machines);
                this.warehouse_dialog = true;
            });
        },
    },
};
</script>
